import styled from '@emotion/styled';

export const DefaultBanner = styled.div`
  height: 100%;
  position: relative;
`;

export const BannerBG = styled.img`
  width: 100%;
  height: auto;
`;

export const DesktopBannerWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  a {
    text-decoration: none;
  }
`;

export const DesktopBannerImageWrapper = styled.div`
  position: relative;
  bottom: 2px;
  left: 220px;
  height: 100%;
  display: flex;
  flex-direction: row-reverse;
  align-items: end;
  max-width: 100%;

  img {
    max-height: 400px;
    height: 88%;
  }
`;

export const DesktopInnerAgentInfo = styled.div`
  position: absolute;
  right: -100px;
  bottom: 40px;
  width: 300px;
  white-space: normal;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  > div {
    position: static;
    margin: 0;
  }
`;

export const DesktopBadgeWrapper = styled.div`
  left: 10px;
  top: 10px;
  position: absolute;
`;

export const DesktopAgentInfo = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.white};
    text-align: right;
    position: relative;
  `}
`;

export const MobileAgentInfo = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.white};
    text-decoration: none;
    width: 100%;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    padding: ${theme.spacing(2)};
    gap: ${theme.spacing(1.5)};
    z-index: 2;

    > div {
      position: static;
      margin: 0;
    }
  `}
`;

export const MobileBannerWrapper = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.brand.lightest};
  `}
  a {
    text-decoration: none;
  }
`;

export const MobileBannerImageWrapper = styled.div`
  width: 100%;
  position: absolute;
  bottom: 2px;

  > img {
    width: 100vw;
    height: auto;
    position: relative;
    top: 2px;
  }

  ${({ theme }) => theme.media.showAt({ at: 2 })`
    > img {
      margin: 0 auto;
      width: calc(100vw - 70px);
    }
  `}
`;

export const MobileBadgeWrapper = styled.div`
  left: 0;
  top: 0;
  position: absolute;
`;

export const MobileTextBG = styled.div`
  position: absolute;
  bottom: 3px;
  width: 100%;
  height: 150px;
  opacity: 0.5;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, #000 100%);
  z-index: 2;
`;
